export enum AirportCodes {
	IAH = 'iah',
	HOU = 'hou',
	EFD = 'efd',
	Spaceport = 'spaceport',
	Corporate = 'corporate',
}

export type AirportTag = {
	[key in AirportCodes]: {
		tag: string;
	};
};

// Tag refers to the contentful tag added to page sections for each specific airport
export const airportTag: AirportTag = {
	[AirportCodes.IAH]: {
		tag: 'web-iah',
	},
	[AirportCodes.HOU]: {
		tag: 'web-hou',
	},
	[AirportCodes.EFD]: {
		tag: 'web-efd',
	},
	[AirportCodes.Spaceport]: {
		tag: 'web-spaceport',
	},
	[AirportCodes.Corporate]: {
		tag: 'web-corporate',
	},
};

export type AirportsColorTheme = {
	[key in AirportCodes]: {
		primary: string;
		onPrimary: string;
		primaryLight: string;
		secondary: string;
		onSecondary: string;
		secondaryLight: string;
		secondaryLighter: string;
	};
};
